import React from 'react';
import classNames from 'classnames';

export interface TabItemProps {
  isActive: boolean;
  onClick: () => void;
  dataTestId?: string;
}

export const TabItem: React.FC<TabItemProps> = ({ children, isActive, onClick, dataTestId }) => (
  <button
    className={classNames('tab__item', {
      'tab__item--active': isActive,
    })}
    onClick={onClick}
    type="button"
    data-testid={dataTestId}
  >
    {children}
  </button>
);
